import React from 'lib/react';

import { IMaskInput } from 'react-imask';
import PropTypes from 'prop-types';

function MaskedPhoneNumber({
  value,
  onChange,
  id,
  ...rest
}) {
  return (
    <IMaskInput
      id={id}
      test-data-id={`mask-input-${id}`}
      mask="000{-}000{-}0000"
      value={value}
      overwrite="shift"
      unmask
      prepare={(str) => str.replace(/\D/gm, '').slice(-10)}
      onAccept={(val, mask, event) => {
        if (event) onChange({ target: { id: event.target.id, value: val.replace(/--/gm, '') } });
      }}
      {...rest}
    />
  );
}

MaskedPhoneNumber.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
};
export default MaskedPhoneNumber;
